const { FACE_INVENTORY_REQUEST, FACE_INVENTORY_SUCCESS, FACE_INVENTORY_FAILED } = require("app/redux/actions/Inventory/FaceInventory/constant");

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const faceInventoryReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case FACE_INVENTORY_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case FACE_INVENTORY_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case FACE_INVENTORY_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};